import { Label } from '@radix-ui/react-label'
import { forwardRef, TextareaHTMLAttributes } from 'react'

type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string
  error?: string
  isError?: boolean
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ id, label, error, isError, className, ...props }, ref) => (
    <div className="mt-2">
      {label && (
        <Label className="text-[14px] font-semibold" htmlFor={id}>
          {label}
        </Label>
      )}

      {isError && <div className="text-error-default mt-1 text-sm">{error}</div>}
      <textarea
        ref={ref}
        id={id}
        {...props}
        className={`${className ?? ''} bg-white border border-borderGray min-h-[134px] mt-2 w-full text-base rounded-md shadow-soft py-3 px-4`}
      />
    </div>
  ),
)

TextArea.displayName = 'TextArea'
